module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VII",
      "title": "VII"
    }
  }, [_c('div', {
    staticClass: "enc2"
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])])])]), _c('span', {
    staticClass: "small"
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab01"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Ante-Nicene Fathers. 10 vols. Edited by Alexander Roberts and James Donaldson. Buffalo, NY: Christian Literature, 1885–1896. Several reprints; also available online.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("CTS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Calvin Translation Society edition of Calvin’s commentaries. 46 vols. Edinburgh, 1843–1855. Several reprints but variously bound; volume numbers (when cited) are relative to specific commentaries and not to the entire set.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("DBWE")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Dietrich Bonhoeffer Works. Vol. 15. Theological Education Underground, 1937–1940. Edited by Victoria Barnett. Minneapolis: Fortress, 2011.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("EEBO")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Early English Books Online. Subscription database: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://eebo.chadwyck.com",
      "target": "_blank"
    }
  }, [_vm._v("http://eebo.chadwyck.com")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("HAB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Herzog August Bibliothek")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Institutes")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("John Calvin. "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(". 2 vols. Edited by J. T. McNeill. Translated by F. L. Battles. Philadelphia: Westminster, 1960.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LCC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Library of Christian Classics")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("LW")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Luther’s Works [American Edition]. 55 vols. St. Louis: Concordia; Philadelphia: Fortress, 1955–1986.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 28 vols. Edited by Philip Schaff et al. Buffalo, NY: Christian Literature, 1887–1894. Several reprints; also available online.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VIII",
      "title": "VIII"
    }
  }, [_vm._v("OER")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Oxford Encyclopedia of the Reformation")]), _vm._v(". 4 vols. Edited by Hans J. Hillerbrand. New York: Oxford University Press, 1996.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Patrologia cursus completus. Series Latina. 221 vols. Edited by J.–P. Migne. Paris, 1857–1866.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("D. Martin Luthers Werke: Kritische Gesamtausgabe. 66 vols. Weimar: Hermann Böhlaus Nachfolger, 1912–1921.")])])])])])])])])])])]), _c('span', {
    staticClass: "small"
  })]), _c('span', {
    staticClass: "small"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0